<template>
  <v-card>

    <v-card-title>
      <div>
        Content Activity
      </div>

      <v-spacer></v-spacer>
      <v-text-field v-model="search"
                    append-icon="fal fa-search"
                    class="pt-0"
                    label="Search"
                    single-line
                    hide-details>
      </v-text-field>
    </v-card-title>

    <v-data-table :headers="headers"
                  :items="items"
                  :items-per-page="5"
                  :loading="loading"
                  :search="search"
                  :sort-by="'device_sessions'"
                  :sort-desc="true"
                  multi-sort
                  fixed-header
                  dense>
      <template v-slot:item.device_sessions_avg_duration="{item}">
        {{ item.device_sessions_avg_duration_human }}
      </template>
      <template v-slot:item.sessions_avg_duration="{item}">
        {{ item.sessions_avg_duration_human }}
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import forOwn from 'lodash/forOwn';
import groupBy from 'lodash/groupBy';
import reduce from 'lodash/reduce';

export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    metrics: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {text: 'Name', value: 'presentation_name', width: '290px'},
        {text: 'In-App Views', value: 'device_sessions',},
        {text: 'In-App Viewers', value: 'device_sessions_users',},
        //{text: 'In-App Avg. Time', value: 'device_sessions_avg_duration',},
        {text: 'Recipient Views', value: 'sessions',},
        {text: 'Recipient Viewers', value: 'sessions_contacts',},
        {text: 'Recipient Avg. Time', value: 'sessions_avg_duration',},
        {text: 'Shares', value: 'shared_links',},
      ],
      search: '',
    }
  },
  computed: {
    items() {
      return this.metrics;
    },
  }
}
</script>
